import * as u from "react";
import { useState as ve, useEffect as xe } from "react";
import { jsx as a, jsxs as d } from "react/jsx-runtime";
import { ChevronDownIcon as L, ChevronRight as he, MoreHorizontal as we, ChevronLeftIcon as ne, ChevronRightIcon as B, ArrowLeft as Ne, ArrowRight as ye, CheckIcon as E, XIcon as ie, SearchIcon as ze, CircleIcon as V, MinusIcon as ke, MoreHorizontalIcon as Ce, GripVerticalIcon as _e, ChevronUpIcon as Se, PanelLeftIcon as Ie, X as Te } from "lucide-react";
import { Accordion as G, Slot as C, AlertDialog as _, AspectRatio as Me, Avatar as Q, Checkbox as te, Collapsible as Z, Dialog as g, ContextMenu as f, DropdownMenu as b, Label as Re, HoverCard as O, Menubar as v, NavigationMenu as T, Popover as $, Progress as ae, RadioGroup as J, ScrollArea as j, Select as h, Separator as De, Tooltip as A, Slider as F, Switch as re, Toast as N, Toggle as Pe, ToggleGroup as se, Tabs as K } from "radix-ui";
import { clsx as Ae } from "clsx";
import { twMerge as je } from "tailwind-merge";
import { cva as z } from "class-variance-authority";
import { getDefaultClassNames as de, DayPicker as Ge } from "react-day-picker";
import $e from "embla-carousel-react";
import { Command as D } from "cmdk";
import { FormProvider as Le, useFormContext as Be, useFormState as Ee, Controller as Fe } from "react-hook-form";
import { OTPInput as Oe, OTPInputContext as He } from "input-otp";
import * as ee from "react-resizable-panels";
import { Toaster as Ve } from "sonner";
const Y = 768;
function Ke() {
  const [e, t] = u.useState(
    void 0
  );
  return u.useEffect(() => {
    const o = window.matchMedia(`(max-width: ${Y - 1}px)`), n = () => {
      t(window.innerWidth < Y);
    };
    return o.addEventListener("change", n), t(window.innerWidth < Y), () => o.removeEventListener("change", n);
  }, []), !!e;
}
function ta() {
  const [e, t] = ve(!1);
  return xe(() => {
    if (typeof window > "u") return;
    const o = () => t(window.innerHeight <= 800);
    return o(), window.addEventListener("resize", o), () => window.removeEventListener("resize", o);
  }, []), e;
}
function r(...e) {
  return je(Ae(e));
}
function aa({
  ...e
}) {
  return /* @__PURE__ */ a(G.Root, { "data-slot": "accordion", ...e });
}
function ra({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    G.Item,
    {
      "data-slot": "accordion-item",
      className: r("border-b last:border-b-0", e),
      ...t
    }
  );
}
function oa({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ a(G.Header, { className: "flex", children: /* @__PURE__ */ d(
    G.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: r(
        "flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        e
      ),
      ...o,
      children: [
        t,
        /* @__PURE__ */ a(L, { className: "pointer-events-none size-4 shrink-0 translate-y-0.5 text-muted-foreground transition-transform duration-200" })
      ]
    }
  ) });
}
function na({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    G.Content,
    {
      "data-slot": "accordion-content",
      className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
      ...o,
      children: /* @__PURE__ */ a("div", { className: r("pt-0 pb-4", e), children: t })
    }
  );
}
const qe = z(
  "relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-lg border px-4 py-3 text-sm has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3 [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive: "bg-card text-destructive *:data-[slot=alert-description]:text-destructive/90 [&>svg]:text-current"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function ia({
  className: e,
  variant: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: r(qe({ variant: t }), e),
      ...o
    }
  );
}
function sa({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-title",
      className: r(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        e
      ),
      ...t
    }
  );
}
function da({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-description",
      className: r(
        "col-start-2 grid justify-items-start gap-1 text-sm text-muted-foreground [&_p]:leading-relaxed",
        e
      ),
      ...t
    }
  );
}
const H = z(
  "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40",
        outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        xs: "h-6 gap-1 rounded-md px-2 text-xs has-[>svg]:px-1.5 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
        "icon-xs": "size-6 rounded-md [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-8",
        "icon-lg": "size-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function M({
  className: e,
  variant: t = "default",
  size: o = "default",
  asChild: n = !1,
  ...i
}) {
  const l = n ? C.Root : "button";
  return /* @__PURE__ */ a(
    l,
    {
      "data-slot": "button",
      "data-variant": t,
      "data-size": o,
      className: r(H({ variant: t, size: o, className: e })),
      ...i
    }
  );
}
function la({
  ...e
}) {
  return /* @__PURE__ */ a(_.Root, { "data-slot": "alert-dialog", ...e });
}
function ua({
  ...e
}) {
  return /* @__PURE__ */ a(_.Trigger, { "data-slot": "alert-dialog-trigger", ...e });
}
function We({
  ...e
}) {
  return /* @__PURE__ */ a(_.Portal, { "data-slot": "alert-dialog-portal", ...e });
}
function Ue({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    _.Overlay,
    {
      "data-slot": "alert-dialog-overlay",
      className: r(
        "fixed inset-0 z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
        e
      ),
      ...t
    }
  );
}
function ca({
  className: e,
  size: t = "default",
  ...o
}) {
  return /* @__PURE__ */ d(We, { children: [
    /* @__PURE__ */ a(Ue, {}),
    /* @__PURE__ */ a(
      _.Content,
      {
        "data-slot": "alert-dialog-content",
        "data-size": t,
        className: r(
          "group/alert-dialog-content fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border bg-background p-6 shadow-lg duration-200 data-[size=sm]:max-w-xs data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[size=default]:sm:max-w-lg",
          e
        ),
        ...o
      }
    )
  ] });
}
function ma({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-dialog-header",
      className: r(
        "grid grid-rows-[auto_1fr] place-items-center gap-1.5 text-center has-data-[slot=alert-dialog-media]:grid-rows-[auto_auto_1fr] has-data-[slot=alert-dialog-media]:gap-x-6 sm:group-data-[size=default]/alert-dialog-content:place-items-start sm:group-data-[size=default]/alert-dialog-content:text-left sm:group-data-[size=default]/alert-dialog-content:has-data-[slot=alert-dialog-media]:grid-rows-[auto_1fr]",
        e
      ),
      ...t
    }
  );
}
function ga({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-dialog-footer",
      className: r(
        "flex flex-col-reverse gap-2 group-data-[size=sm]/alert-dialog-content:grid group-data-[size=sm]/alert-dialog-content:grid-cols-2 sm:flex-row sm:justify-end",
        e
      ),
      ...t
    }
  );
}
function pa({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    _.Title,
    {
      "data-slot": "alert-dialog-title",
      className: r(
        "text-lg font-semibold sm:group-data-[size=default]/alert-dialog-content:group-has-data-[slot=alert-dialog-media]/alert-dialog-content:col-start-2",
        e
      ),
      ...t
    }
  );
}
function fa({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    _.Description,
    {
      "data-slot": "alert-dialog-description",
      className: r("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function ba({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "alert-dialog-media",
      className: r(
        "mb-2 inline-flex size-16 items-center justify-center rounded-md bg-muted sm:group-data-[size=default]/alert-dialog-content:row-span-2 *:[svg:not([class*='size-'])]:size-8",
        e
      ),
      ...t
    }
  );
}
function va({
  className: e,
  variant: t = "default",
  size: o = "default",
  ...n
}) {
  return /* @__PURE__ */ a(M, { variant: t, size: o, asChild: !0, children: /* @__PURE__ */ a(
    _.Action,
    {
      "data-slot": "alert-dialog-action",
      className: r(e),
      ...n
    }
  ) });
}
function xa({
  className: e,
  variant: t = "outline",
  size: o = "default",
  ...n
}) {
  return /* @__PURE__ */ a(M, { variant: t, size: o, asChild: !0, children: /* @__PURE__ */ a(
    _.Cancel,
    {
      "data-slot": "alert-dialog-cancel",
      className: r(e),
      ...n
    }
  ) });
}
function ha({
  ...e
}) {
  return /* @__PURE__ */ a(Me.Root, { "data-slot": "aspect-ratio", ...e });
}
function wa({
  className: e,
  size: t = "default",
  ...o
}) {
  return /* @__PURE__ */ a(
    Q.Root,
    {
      "data-slot": "avatar",
      "data-size": t,
      className: r(
        "group/avatar relative flex size-8 shrink-0 overflow-hidden rounded-full select-none data-[size=lg]:size-10 data-[size=sm]:size-6",
        e
      ),
      ...o
    }
  );
}
function Na({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    Q.Image,
    {
      "data-slot": "avatar-image",
      className: r("aspect-square size-full", e),
      ...t
    }
  );
}
function ya({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    Q.Fallback,
    {
      "data-slot": "avatar-fallback",
      className: r(
        "flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs",
        e
      ),
      ...t
    }
  );
}
function za({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "avatar-badge",
      className: r(
        "absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground ring-2 ring-background select-none",
        "group-data-[size=sm]/avatar:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden",
        "group-data-[size=default]/avatar:size-2.5 group-data-[size=default]/avatar:[&>svg]:size-2",
        "group-data-[size=lg]/avatar:size-3 group-data-[size=lg]/avatar:[&>svg]:size-2",
        e
      ),
      ...t
    }
  );
}
function ka({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "avatar-group",
      className: r(
        "group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background",
        e
      ),
      ...t
    }
  );
}
function Ca({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "avatar-group-count",
      className: r(
        "relative flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm text-muted-foreground ring-2 ring-background group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3",
        e
      ),
      ...t
    }
  );
}
const Xe = z(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
        secondary: "bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
        destructive: "bg-destructive text-white focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40 [a&]:hover:bg-destructive/90",
        outline: "border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        ghost: "[a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        link: "text-primary underline-offset-4 [a&]:hover:underline"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function _a({
  className: e,
  variant: t = "default",
  asChild: o = !1,
  ...n
}) {
  const i = o ? C.Root : "span";
  return /* @__PURE__ */ a(
    i,
    {
      "data-slot": "badge",
      "data-variant": t,
      className: r(Xe({ variant: t }), e),
      ...n
    }
  );
}
function Sa({ ...e }) {
  return /* @__PURE__ */ a("nav", { "aria-label": "breadcrumb", "data-slot": "breadcrumb", ...e });
}
function Ia({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "ol",
    {
      "data-slot": "breadcrumb-list",
      className: r(
        "flex flex-wrap items-center gap-1.5 text-sm break-words text-muted-foreground sm:gap-2.5",
        e
      ),
      ...t
    }
  );
}
function Ta({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "li",
    {
      "data-slot": "breadcrumb-item",
      className: r("inline-flex items-center gap-1.5", e),
      ...t
    }
  );
}
function Ma({
  asChild: e,
  className: t,
  ...o
}) {
  const n = e ? C.Root : "a";
  return /* @__PURE__ */ a(
    n,
    {
      "data-slot": "breadcrumb-link",
      className: r("transition-colors hover:text-foreground", t),
      ...o
    }
  );
}
function Ra({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "breadcrumb-page",
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: r("font-normal text-foreground", e),
      ...t
    }
  );
}
function Da({
  children: e,
  className: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    "li",
    {
      "data-slot": "breadcrumb-separator",
      role: "presentation",
      "aria-hidden": "true",
      className: r("[&>svg]:size-3.5", t),
      ...o,
      children: e ?? /* @__PURE__ */ a(he, {})
    }
  );
}
function Pa({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ d(
    "span",
    {
      "data-slot": "breadcrumb-ellipsis",
      role: "presentation",
      "aria-hidden": "true",
      className: r("flex size-9 items-center justify-center", e),
      ...t,
      children: [
        /* @__PURE__ */ a(we, { className: "size-4" }),
        /* @__PURE__ */ a("span", { className: "sr-only", children: "More" })
      ]
    }
  );
}
function Aa({
  className: e,
  classNames: t,
  showOutsideDays: o = !0,
  captionLayout: n = "label",
  buttonVariant: i = "ghost",
  formatters: l,
  components: p,
  ...x
}) {
  const s = de();
  return /* @__PURE__ */ a(
    Ge,
    {
      showOutsideDays: o,
      className: r(
        "group/calendar bg-background p-3 [--cell-size:--spacing(8)] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      captionLayout: n,
      formatters: {
        formatMonthDropdown: (c) => c.toLocaleString("default", { month: "short" }),
        ...l
      },
      classNames: {
        root: r("w-fit", s.root),
        months: r(
          "relative flex flex-col gap-4 md:flex-row",
          s.months
        ),
        month: r("flex w-full flex-col gap-4", s.month),
        nav: r(
          "absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1",
          s.nav
        ),
        button_previous: r(
          H({ variant: i }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          s.button_previous
        ),
        button_next: r(
          H({ variant: i }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          s.button_next
        ),
        month_caption: r(
          "flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)",
          s.month_caption
        ),
        dropdowns: r(
          "flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium",
          s.dropdowns
        ),
        dropdown_root: r(
          "relative rounded-md border border-input shadow-xs has-focus:border-ring has-focus:ring-[3px] has-focus:ring-ring/50",
          s.dropdown_root
        ),
        dropdown: r(
          "absolute inset-0 bg-popover opacity-0",
          s.dropdown
        ),
        caption_label: r(
          "font-medium select-none",
          n === "label" ? "text-sm" : "flex h-8 items-center gap-1 rounded-md pr-1 pl-2 text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground",
          s.caption_label
        ),
        month_grid: r("w-full border-collapse", s.month_grid),
        weekdays: r("flex", s.weekdays),
        weekday: r(
          "flex-1 rounded-md text-[0.8rem] font-normal text-muted-foreground select-none",
          s.weekday
        ),
        week: r("mt-2 flex w-full", s.week),
        week_number_header: r(
          "w-(--cell-size) select-none",
          s.week_number_header
        ),
        week_number: r(
          "text-[0.8rem] text-muted-foreground select-none",
          s.week_number
        ),
        day: r(
          "group/day relative aspect-square h-full w-full p-0 text-center select-none [&:last-child[data-selected=true]_button]:rounded-r-md",
          x.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-md" : "[&:first-child[data-selected=true]_button]:rounded-l-md",
          s.day
        ),
        range_start: r(
          "rounded-l-md bg-accent",
          s.range_start
        ),
        range_middle: r("rounded-none", s.range_middle),
        range_end: r("rounded-r-md bg-accent", s.range_end),
        today: r(
          "rounded-md bg-accent text-accent-foreground data-[selected=true]:rounded-none",
          s.today
        ),
        outside: r(
          "text-muted-foreground aria-selected:text-muted-foreground",
          s.outside
        ),
        disabled: r(
          "text-muted-foreground opacity-50",
          s.disabled
        ),
        hidden: r("invisible", s.hidden),
        ...t
      },
      components: {
        Root: ({ className: c, rootRef: w, ...k }) => /* @__PURE__ */ a(
          "div",
          {
            "data-slot": "calendar",
            ref: w,
            className: r(c),
            ...k
          }
        ),
        Chevron: ({ className: c, orientation: w, ...k }) => w === "left" ? /* @__PURE__ */ a(ne, { className: r("size-4", c), ...k }) : w === "right" ? /* @__PURE__ */ a(
          B,
          {
            className: r("size-4", c),
            ...k
          }
        ) : /* @__PURE__ */ a(L, { className: r("size-4", c), ...k }),
        DayButton: Ye,
        WeekNumber: ({ children: c, ...w }) => /* @__PURE__ */ a("td", { ...w, children: /* @__PURE__ */ a("div", { className: "flex size-(--cell-size) items-center justify-center text-center", children: c }) }),
        ...p
      },
      ...x
    }
  );
}
function Ye({
  className: e,
  day: t,
  modifiers: o,
  ...n
}) {
  const i = de(), l = u.useRef(null);
  return u.useEffect(() => {
    o.focused && l.current?.focus();
  }, [o.focused]), /* @__PURE__ */ a(
    M,
    {
      ref: l,
      variant: "ghost",
      size: "icon",
      "data-day": t.date.toLocaleDateString(),
      "data-selected-single": o.selected && !o.range_start && !o.range_end && !o.range_middle,
      "data-range-start": o.range_start,
      "data-range-end": o.range_end,
      "data-range-middle": o.range_middle,
      className: r(
        "flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 data-[range-end=true]:rounded-md data-[range-end=true]:rounded-r-md data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-accent data-[range-middle=true]:text-accent-foreground data-[range-start=true]:rounded-md data-[range-start=true]:rounded-l-md data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground dark:hover:text-accent-foreground [&>span]:text-xs [&>span]:opacity-70",
        i.day,
        e
      ),
      ...n
    }
  );
}
function ja({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card",
      className: r(
        "flex flex-col gap-6 rounded-xl border bg-card py-6 text-card-foreground shadow-sm",
        e
      ),
      ...t
    }
  );
}
function Ga({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-header",
      className: r(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        e
      ),
      ...t
    }
  );
}
function $a({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-title",
      className: r("leading-none font-semibold", e),
      ...t
    }
  );
}
function La({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-description",
      className: r("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function Ba({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-action",
      className: r(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        e
      ),
      ...t
    }
  );
}
function Ea({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-content",
      className: r("px-6", e),
      ...t
    }
  );
}
function Fa({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "card-footer",
      className: r("flex items-center px-6 [.border-t]:pt-6", e),
      ...t
    }
  );
}
const le = u.createContext(null);
function q() {
  const e = u.useContext(le);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
function Oa({
  orientation: e = "horizontal",
  opts: t,
  setApi: o,
  plugins: n,
  className: i,
  children: l,
  ...p
}) {
  const [x, s] = $e(
    {
      ...t,
      axis: e === "horizontal" ? "x" : "y"
    },
    n
  ), [c, w] = u.useState(!1), [k, R] = u.useState(!1), y = u.useCallback((m) => {
    m && (w(m.canScrollPrev()), R(m.canScrollNext()));
  }, []), S = u.useCallback(() => {
    s?.scrollPrev();
  }, [s]), P = u.useCallback(() => {
    s?.scrollNext();
  }, [s]), X = u.useCallback(
    (m) => {
      m.key === "ArrowLeft" ? (m.preventDefault(), S()) : m.key === "ArrowRight" && (m.preventDefault(), P());
    },
    [S, P]
  );
  return u.useEffect(() => {
    !s || !o || o(s);
  }, [s, o]), u.useEffect(() => {
    if (s)
      return y(s), s.on("reInit", y), s.on("select", y), () => {
        s?.off("select", y);
      };
  }, [s, y]), /* @__PURE__ */ a(
    le.Provider,
    {
      value: {
        carouselRef: x,
        api: s,
        opts: t,
        orientation: e || (t?.axis === "y" ? "vertical" : "horizontal"),
        scrollPrev: S,
        scrollNext: P,
        canScrollPrev: c,
        canScrollNext: k
      },
      children: /* @__PURE__ */ a(
        "div",
        {
          onKeyDownCapture: X,
          className: r("relative", i),
          role: "region",
          "aria-roledescription": "carousel",
          "data-slot": "carousel",
          ...p,
          children: l
        }
      )
    }
  );
}
function Ha({ className: e, ...t }) {
  const { carouselRef: o, orientation: n } = q();
  return /* @__PURE__ */ a(
    "div",
    {
      ref: o,
      className: "overflow-hidden",
      "data-slot": "carousel-content",
      children: /* @__PURE__ */ a(
        "div",
        {
          className: r(
            "flex",
            n === "horizontal" ? "-ml-4" : "-mt-4 flex-col",
            e
          ),
          ...t
        }
      )
    }
  );
}
function Va({ className: e, ...t }) {
  const { orientation: o } = q();
  return /* @__PURE__ */ a(
    "div",
    {
      role: "group",
      "aria-roledescription": "slide",
      "data-slot": "carousel-item",
      className: r(
        "min-w-0 shrink-0 grow-0 basis-full",
        o === "horizontal" ? "pl-4" : "pt-4",
        e
      ),
      ...t
    }
  );
}
function Ka({
  className: e,
  variant: t = "outline",
  size: o = "icon",
  ...n
}) {
  const { orientation: i, scrollPrev: l, canScrollPrev: p } = q();
  return /* @__PURE__ */ d(
    M,
    {
      "data-slot": "carousel-previous",
      variant: t,
      size: o,
      className: r(
        "absolute size-8 rounded-full",
        i === "horizontal" ? "top-1/2 -left-12 -translate-y-1/2" : "-top-12 left-1/2 -translate-x-1/2 rotate-90",
        e
      ),
      disabled: !p,
      onClick: l,
      ...n,
      children: [
        /* @__PURE__ */ a(Ne, {}),
        /* @__PURE__ */ a("span", { className: "sr-only", children: "Previous slide" })
      ]
    }
  );
}
function qa({
  className: e,
  variant: t = "outline",
  size: o = "icon",
  ...n
}) {
  const { orientation: i, scrollNext: l, canScrollNext: p } = q();
  return /* @__PURE__ */ d(
    M,
    {
      "data-slot": "carousel-next",
      variant: t,
      size: o,
      className: r(
        "absolute size-8 rounded-full",
        i === "horizontal" ? "top-1/2 -right-12 -translate-y-1/2" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90",
        e
      ),
      disabled: !p,
      onClick: l,
      ...n,
      children: [
        /* @__PURE__ */ a(ye, {}),
        /* @__PURE__ */ a("span", { className: "sr-only", children: "Next slide" })
      ]
    }
  );
}
function Wa({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    te.Root,
    {
      "data-slot": "checkbox",
      className: r(
        "peer size-4 shrink-0 rounded-[4px] border border-input shadow-xs transition-shadow outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:bg-input/30 dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-primary",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(
        te.Indicator,
        {
          "data-slot": "checkbox-indicator",
          className: "grid place-content-center text-current transition-none",
          children: /* @__PURE__ */ a(E, { className: "size-3.5" })
        }
      )
    }
  );
}
function Ua({
  ...e
}) {
  return /* @__PURE__ */ a(Z.Root, { "data-slot": "collapsible", ...e });
}
function Xa({
  ...e
}) {
  return /* @__PURE__ */ a(
    Z.CollapsibleTrigger,
    {
      "data-slot": "collapsible-trigger",
      ...e
    }
  );
}
function Ya({
  ...e
}) {
  return /* @__PURE__ */ a(
    Z.CollapsibleContent,
    {
      "data-slot": "collapsible-content",
      ...e
    }
  );
}
function Je({
  ...e
}) {
  return /* @__PURE__ */ a(g.Root, { "data-slot": "dialog", ...e });
}
function Ja({
  ...e
}) {
  return /* @__PURE__ */ a(g.Trigger, { "data-slot": "dialog-trigger", ...e });
}
function Qe({
  ...e
}) {
  return /* @__PURE__ */ a(g.Portal, { "data-slot": "dialog-portal", ...e });
}
function Qa({
  ...e
}) {
  return /* @__PURE__ */ a(g.Close, { "data-slot": "dialog-close", ...e });
}
function Ze({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    g.Overlay,
    {
      "data-slot": "dialog-overlay",
      className: r(
        "fixed inset-0 z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
        e
      ),
      ...t
    }
  );
}
function et({
  className: e,
  children: t,
  showCloseButton: o = !0,
  ...n
}) {
  return /* @__PURE__ */ d(Qe, { "data-slot": "dialog-portal", children: [
    /* @__PURE__ */ a(Ze, {}),
    /* @__PURE__ */ d(
      g.Content,
      {
        "data-slot": "dialog-content",
        className: r(
          "fixed top-[50%] left-[50%] z-50 grid max-h-[calc(100%-2rem)] w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 overflow-y-auto rounded-lg border bg-background p-6 shadow-lg duration-200 outline-none data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:max-w-lg",
          e
        ),
        ...n,
        children: [
          t,
          o && /* @__PURE__ */ d(
            g.Close,
            {
              "data-slot": "dialog-close",
              className: "absolute top-4 end-4 flex size-7 cursor-pointer items-center justify-center rounded-xs bg-muted opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
              children: [
                /* @__PURE__ */ a(ie, { className: "text-muted-foreground" }),
                /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function tt({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "dialog-header",
      className: r("flex flex-col gap-2 text-center sm:text-left", e),
      ...t
    }
  );
}
function Za({
  className: e,
  showCloseButton: t = !1,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      "data-slot": "dialog-footer",
      className: r(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        e
      ),
      ...n,
      children: [
        o,
        t && /* @__PURE__ */ a(g.Close, { asChild: !0, children: /* @__PURE__ */ a(M, { variant: "outline", children: "Close" }) })
      ]
    }
  );
}
function at({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    g.Title,
    {
      "data-slot": "dialog-title",
      className: r("text-lg leading-none font-semibold", e),
      ...t
    }
  );
}
function rt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    g.Description,
    {
      "data-slot": "dialog-description",
      className: r("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function ot({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    D,
    {
      "data-slot": "command",
      className: r(
        "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
        e
      ),
      ...t
    }
  );
}
function er({
  title: e = "Command Palette",
  description: t = "Search for a command to run...",
  children: o,
  className: n,
  showCloseButton: i = !0,
  ...l
}) {
  return /* @__PURE__ */ d(Je, { ...l, children: [
    /* @__PURE__ */ d(tt, { className: "sr-only", children: [
      /* @__PURE__ */ a(at, { children: e }),
      /* @__PURE__ */ a(rt, { children: t })
    ] }),
    /* @__PURE__ */ a(
      et,
      {
        className: r("overflow-hidden p-0", n),
        showCloseButton: i,
        children: /* @__PURE__ */ a(ot, { className: "**:data-[slot=command-input-wrapper]:h-12 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: o })
      }
    )
  ] });
}
function tr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      "data-slot": "command-input-wrapper",
      className: "flex h-9 items-center gap-2 border-b px-3",
      children: [
        /* @__PURE__ */ a(ze, { className: "size-4 shrink-0 opacity-50" }),
        /* @__PURE__ */ a(
          D.Input,
          {
            "data-slot": "command-input",
            className: r(
              "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
              e
            ),
            ...t
          }
        )
      ]
    }
  );
}
function ar({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    D.List,
    {
      "data-slot": "command-list",
      className: r(
        "max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto",
        e
      ),
      ...t
    }
  );
}
function rr({
  ...e
}) {
  return /* @__PURE__ */ a(
    D.Empty,
    {
      "data-slot": "command-empty",
      className: "py-6 text-center text-sm",
      ...e
    }
  );
}
function or({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    D.Group,
    {
      "data-slot": "command-group",
      className: r(
        "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function nr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    D.Separator,
    {
      "data-slot": "command-separator",
      className: r("-mx-1 h-px bg-border", e),
      ...t
    }
  );
}
function ir({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    D.Item,
    {
      "data-slot": "command-item",
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function sr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "command-shortcut",
      className: r(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function dr({
  ...e
}) {
  return /* @__PURE__ */ a(f.Root, { "data-slot": "context-menu", ...e });
}
function lr({
  ...e
}) {
  return /* @__PURE__ */ a(f.Trigger, { "data-slot": "context-menu-trigger", ...e });
}
function ur({
  ...e
}) {
  return /* @__PURE__ */ a(f.Group, { "data-slot": "context-menu-group", ...e });
}
function cr({
  ...e
}) {
  return /* @__PURE__ */ a(f.Portal, { "data-slot": "context-menu-portal", ...e });
}
function mr({
  ...e
}) {
  return /* @__PURE__ */ a(f.Sub, { "data-slot": "context-menu-sub", ...e });
}
function gr({
  ...e
}) {
  return /* @__PURE__ */ a(
    f.RadioGroup,
    {
      "data-slot": "context-menu-radio-group",
      ...e
    }
  );
}
function pr({
  className: e,
  inset: t,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ d(
    f.SubTrigger,
    {
      "data-slot": "context-menu-sub-trigger",
      "data-inset": t,
      className: r(
        "flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[inset]:pl-8 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        e
      ),
      ...n,
      children: [
        o,
        /* @__PURE__ */ a(B, { className: "ml-auto" })
      ]
    }
  );
}
function fr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    f.SubContent,
    {
      "data-slot": "context-menu-sub-content",
      className: r(
        "z-50 min-w-[8rem] origin-(--radix-context-menu-content-transform-origin) overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...t
    }
  );
}
function br({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(f.Portal, { children: /* @__PURE__ */ a(
    f.Content,
    {
      "data-slot": "context-menu-content",
      className: r(
        "z-50 max-h-(--radix-context-menu-content-available-height) min-w-[8rem] origin-(--radix-context-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...t
    }
  ) });
}
function vr({
  className: e,
  inset: t,
  variant: o = "default",
  ...n
}) {
  return /* @__PURE__ */ a(
    f.Item,
    {
      "data-slot": "context-menu-item",
      "data-inset": t,
      "data-variant": o,
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground data-[variant=destructive]:*:[svg]:text-destructive!",
        e
      ),
      ...n
    }
  );
}
function xr({
  className: e,
  children: t,
  checked: o,
  ...n
}) {
  return /* @__PURE__ */ d(
    f.CheckboxItem,
    {
      "data-slot": "context-menu-checkbox-item",
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: o,
      ...n,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(f.ItemIndicator, { children: /* @__PURE__ */ a(E, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function hr({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ d(
    f.RadioItem,
    {
      "data-slot": "context-menu-radio-item",
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(f.ItemIndicator, { children: /* @__PURE__ */ a(V, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function wr({
  className: e,
  inset: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    f.Label,
    {
      "data-slot": "context-menu-label",
      "data-inset": t,
      className: r(
        "px-2 py-1.5 text-sm font-medium text-foreground data-[inset]:pl-8",
        e
      ),
      ...o
    }
  );
}
function Nr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    f.Separator,
    {
      "data-slot": "context-menu-separator",
      className: r("-mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function yr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "context-menu-shortcut",
      className: r(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function zr({
  ...e
}) {
  return /* @__PURE__ */ a(b.Root, { "data-slot": "dropdown-menu", ...e });
}
function kr({
  ...e
}) {
  return /* @__PURE__ */ a(b.Portal, { "data-slot": "dropdown-menu-portal", ...e });
}
function Cr({
  ...e
}) {
  return /* @__PURE__ */ a(
    b.Trigger,
    {
      "data-slot": "dropdown-menu-trigger",
      ...e
    }
  );
}
function _r({
  className: e,
  sideOffset: t = 4,
  ...o
}) {
  return /* @__PURE__ */ a(b.Portal, { children: /* @__PURE__ */ a(
    b.Content,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset: t,
      className: r(
        "z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...o
    }
  ) });
}
function Sr({
  ...e
}) {
  return /* @__PURE__ */ a(b.Group, { "data-slot": "dropdown-menu-group", ...e });
}
function Ir({
  className: e,
  inset: t,
  variant: o = "default",
  ...n
}) {
  return /* @__PURE__ */ a(
    b.Item,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": t,
      "data-variant": o,
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground data-[variant=destructive]:*:[svg]:text-destructive!",
        e
      ),
      ...n
    }
  );
}
function Tr({
  className: e,
  children: t,
  checked: o,
  ...n
}) {
  return /* @__PURE__ */ d(
    b.CheckboxItem,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: o,
      ...n,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(b.ItemIndicator, { children: /* @__PURE__ */ a(E, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function Mr({
  ...e
}) {
  return /* @__PURE__ */ a(
    b.RadioGroup,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function Rr({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ d(
    b.RadioItem,
    {
      "data-slot": "dropdown-menu-radio-item",
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(b.ItemIndicator, { children: /* @__PURE__ */ a(V, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function Dr({
  className: e,
  inset: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    b.Label,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": t,
      className: r(
        "px-2 py-1.5 text-sm font-medium data-[inset]:pl-8",
        e
      ),
      ...o
    }
  );
}
function Pr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    b.Separator,
    {
      "data-slot": "dropdown-menu-separator",
      className: r("-mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function Ar({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: r(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function jr({
  ...e
}) {
  return /* @__PURE__ */ a(b.Sub, { "data-slot": "dropdown-menu-sub", ...e });
}
function Gr({
  className: e,
  inset: t,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ d(
    b.SubTrigger,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": t,
      className: r(
        "flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[inset]:pl-8 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        e
      ),
      ...n,
      children: [
        o,
        /* @__PURE__ */ a(B, { className: "ml-auto size-4" })
      ]
    }
  );
}
function $r({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    b.SubContent,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: r(
        "z-50 min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...t
    }
  );
}
function nt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    Re.Root,
    {
      "data-slot": "label",
      className: r(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
const Lr = Le, ue = u.createContext(
  {}
), Br = ({
  ...e
}) => /* @__PURE__ */ a(ue.Provider, { value: { name: e.name }, children: /* @__PURE__ */ a(Fe, { ...e }) }), W = () => {
  const e = u.useContext(ue), t = u.useContext(ce), { getFieldState: o } = Be(), n = Ee({ name: e.name }), i = o(e.name, n);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: l } = t;
  return {
    id: l,
    name: e.name,
    formItemId: `${l}-form-item`,
    formDescriptionId: `${l}-form-item-description`,
    formMessageId: `${l}-form-item-message`,
    ...i
  };
}, ce = u.createContext(
  {}
);
function Er({ className: e, ...t }) {
  const o = u.useId();
  return /* @__PURE__ */ a(ce.Provider, { value: { id: o }, children: /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "form-item",
      className: r("grid gap-2", e),
      ...t
    }
  ) });
}
function Fr({
  className: e,
  ...t
}) {
  const { error: o, formItemId: n } = W();
  return /* @__PURE__ */ a(
    nt,
    {
      "data-slot": "form-label",
      "data-error": !!o,
      className: r("data-[error=true]:text-destructive", e),
      htmlFor: n,
      ...t
    }
  );
}
function Or({ ...e }) {
  const { error: t, formItemId: o, formDescriptionId: n, formMessageId: i } = W();
  return /* @__PURE__ */ a(
    C.Root,
    {
      "data-slot": "form-control",
      id: o,
      "aria-describedby": t ? `${n} ${i}` : `${n}`,
      "aria-invalid": !!t,
      ...e
    }
  );
}
function Hr({ className: e, ...t }) {
  const { formDescriptionId: o } = W();
  return /* @__PURE__ */ a(
    "p",
    {
      "data-slot": "form-description",
      id: o,
      className: r("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function Vr({ className: e, ...t }) {
  const { error: o, formMessageId: n } = W(), i = o ? String(o?.message ?? "") : t.children;
  return i ? /* @__PURE__ */ a(
    "p",
    {
      "data-slot": "form-message",
      id: n,
      className: r("text-sm text-destructive", e),
      ...t,
      children: i
    }
  ) : null;
}
function Kr({
  ...e
}) {
  return /* @__PURE__ */ a(O.Root, { "data-slot": "hover-card", ...e });
}
function qr({
  ...e
}) {
  return /* @__PURE__ */ a(O.Trigger, { "data-slot": "hover-card-trigger", ...e });
}
function Wr({
  className: e,
  align: t = "center",
  sideOffset: o = 4,
  ...n
}) {
  return /* @__PURE__ */ a(O.Portal, { "data-slot": "hover-card-portal", children: /* @__PURE__ */ a(
    O.Content,
    {
      "data-slot": "hover-card-content",
      align: t,
      sideOffset: o,
      className: r(
        "z-50 w-64 origin-(--radix-hover-card-content-transform-origin) rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...n
    }
  ) });
}
function me({ className: e, type: t, ...o }) {
  return /* @__PURE__ */ a(
    "input",
    {
      type: t,
      "data-slot": "input",
      className: r(
        "h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...o
    }
  );
}
function it({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "textarea",
    {
      "data-slot": "textarea",
      className: r(
        "flex field-sizing-content min-h-16 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...t
    }
  );
}
function Ur({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "input-group",
      role: "group",
      className: r(
        "group/input-group relative flex w-full items-center rounded-md border border-input shadow-xs transition-[color,box-shadow] outline-none dark:bg-input/30",
        "h-9 min-w-0 has-[>textarea]:h-auto",
        // Variants based on alignment.
        "has-[>[data-align=inline-start]]:[&>input]:pl-2",
        "has-[>[data-align=inline-end]]:[&>input]:pr-2",
        "has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>[data-align=block-start]]:[&>input]:pb-3",
        "has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-end]]:[&>input]:pt-3",
        // Focus state.
        "has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-[3px] has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50",
        // Error state.
        "has-[[data-slot][aria-invalid=true]]:border-destructive has-[[data-slot][aria-invalid=true]]:ring-destructive/20 dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40",
        e
      ),
      ...t
    }
  );
}
const st = z(
  "flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium text-muted-foreground select-none group-data-[disabled=true]/input-group:opacity-50 [&>kbd]:rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-4",
  {
    variants: {
      align: {
        "inline-start": "order-first pl-3 has-[>button]:ml-[-0.45rem] has-[>kbd]:ml-[-0.35rem]",
        "inline-end": "order-last pr-3 has-[>button]:mr-[-0.45rem] has-[>kbd]:mr-[-0.35rem]",
        "block-start": "order-first w-full justify-start px-3 pt-3 group-has-[>input]/input-group:pt-2.5 [.border-b]:pb-3",
        "block-end": "order-last w-full justify-start px-3 pb-3 group-has-[>input]/input-group:pb-2.5 [.border-t]:pt-3"
      }
    },
    defaultVariants: {
      align: "inline-start"
    }
  }
);
function Xr({
  className: e,
  align: t = "inline-start",
  ...o
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      role: "group",
      "data-slot": "input-group-addon",
      "data-align": t,
      className: r(st({ align: t }), e),
      onClick: (n) => {
        n.target.closest("button") || n.currentTarget.parentElement?.querySelector("input")?.focus();
      },
      ...o
    }
  );
}
const dt = z(
  "flex items-center gap-2 text-sm shadow-none",
  {
    variants: {
      size: {
        xs: "h-6 gap-1 rounded-[calc(var(--radius)-5px)] px-2 has-[>svg]:px-2 [&>svg:not([class*='size-'])]:size-3.5",
        sm: "h-8 gap-1.5 rounded-md px-2.5 has-[>svg]:px-2.5",
        "icon-xs": "size-6 rounded-[calc(var(--radius)-5px)] p-0 has-[>svg]:p-0",
        "icon-sm": "size-8 p-0 has-[>svg]:p-0"
      }
    },
    defaultVariants: {
      size: "xs"
    }
  }
);
function Yr({
  className: e,
  type: t = "button",
  variant: o = "ghost",
  size: n = "xs",
  ...i
}) {
  return /* @__PURE__ */ a(
    M,
    {
      type: t,
      "data-size": n,
      variant: o,
      className: r(dt({ size: n }), e),
      ...i
    }
  );
}
function Jr({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "span",
    {
      className: r(
        "flex items-center gap-2 text-sm text-muted-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...t
    }
  );
}
function Qr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    me,
    {
      "data-slot": "input-group-control",
      className: r(
        "flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0 dark:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function Zr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    it,
    {
      "data-slot": "input-group-control",
      className: r(
        "flex-1 resize-none rounded-none border-0 bg-transparent py-3 shadow-none focus-visible:ring-0 dark:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function eo({
  className: e,
  containerClassName: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    Oe,
    {
      "data-slot": "input-otp",
      containerClassName: r(
        "flex items-center gap-2 has-disabled:opacity-50",
        t
      ),
      className: r("disabled:cursor-not-allowed", e),
      ...o
    }
  );
}
function to({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "input-otp-group",
      className: r("flex items-center", e),
      ...t
    }
  );
}
function ao({
  index: e,
  className: t,
  ...o
}) {
  const n = u.useContext(He), { char: i, hasFakeCaret: l, isActive: p } = n?.slots[e] ?? {};
  return /* @__PURE__ */ d(
    "div",
    {
      "data-slot": "input-otp-slot",
      "data-active": p,
      className: r(
        "relative flex h-9 w-9 items-center justify-center border-y border-r border-input text-sm shadow-xs transition-all outline-none first:rounded-l-md first:border-l last:rounded-r-md aria-invalid:border-destructive data-[active=true]:z-10 data-[active=true]:border-ring data-[active=true]:ring-[3px] data-[active=true]:ring-ring/50 data-[active=true]:aria-invalid:border-destructive data-[active=true]:aria-invalid:ring-destructive/20 dark:bg-input/30 dark:data-[active=true]:aria-invalid:ring-destructive/40",
        t
      ),
      ...o,
      children: [
        i,
        l && /* @__PURE__ */ a("div", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ a("div", { className: "h-4 w-px animate-caret-blink bg-foreground duration-1000" }) })
      ]
    }
  );
}
function ro({ ...e }) {
  return /* @__PURE__ */ a("div", { "data-slot": "input-otp-separator", role: "separator", ...e, children: /* @__PURE__ */ a(ke, {}) });
}
function oo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    v.Root,
    {
      "data-slot": "menubar",
      className: r(
        "flex h-9 items-center gap-1 rounded-md border bg-background p-1 shadow-xs",
        e
      ),
      ...t
    }
  );
}
function no({
  ...e
}) {
  return /* @__PURE__ */ a(v.Menu, { "data-slot": "menubar-menu", ...e });
}
function io({
  ...e
}) {
  return /* @__PURE__ */ a(v.Group, { "data-slot": "menubar-group", ...e });
}
function lt({
  ...e
}) {
  return /* @__PURE__ */ a(v.Portal, { "data-slot": "menubar-portal", ...e });
}
function so({
  ...e
}) {
  return /* @__PURE__ */ a(v.RadioGroup, { "data-slot": "menubar-radio-group", ...e });
}
function lo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    v.Trigger,
    {
      "data-slot": "menubar-trigger",
      className: r(
        "flex items-center rounded-sm px-2 py-1 text-sm font-medium outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground",
        e
      ),
      ...t
    }
  );
}
function uo({
  className: e,
  align: t = "start",
  alignOffset: o = -4,
  sideOffset: n = 8,
  ...i
}) {
  return /* @__PURE__ */ a(lt, { children: /* @__PURE__ */ a(
    v.Content,
    {
      "data-slot": "menubar-content",
      align: t,
      alignOffset: o,
      sideOffset: n,
      className: r(
        "z-50 min-w-[12rem] origin-(--radix-menubar-content-transform-origin) overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...i
    }
  ) });
}
function co({
  className: e,
  inset: t,
  variant: o = "default",
  ...n
}) {
  return /* @__PURE__ */ a(
    v.Item,
    {
      "data-slot": "menubar-item",
      "data-inset": t,
      "data-variant": o,
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground data-[variant=destructive]:*:[svg]:text-destructive!",
        e
      ),
      ...n
    }
  );
}
function mo({
  className: e,
  children: t,
  checked: o,
  ...n
}) {
  return /* @__PURE__ */ d(
    v.CheckboxItem,
    {
      "data-slot": "menubar-checkbox-item",
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-xs py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: o,
      ...n,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(v.ItemIndicator, { children: /* @__PURE__ */ a(E, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function go({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ d(
    v.RadioItem,
    {
      "data-slot": "menubar-radio-item",
      className: r(
        "relative flex cursor-default items-center gap-2 rounded-xs py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...o,
      children: [
        /* @__PURE__ */ a("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ a(v.ItemIndicator, { children: /* @__PURE__ */ a(V, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function po({
  className: e,
  inset: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    v.Label,
    {
      "data-slot": "menubar-label",
      "data-inset": t,
      className: r(
        "px-2 py-1.5 text-sm font-medium data-[inset]:pl-8",
        e
      ),
      ...o
    }
  );
}
function fo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    v.Separator,
    {
      "data-slot": "menubar-separator",
      className: r("-mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function bo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "span",
    {
      "data-slot": "menubar-shortcut",
      className: r(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function vo({
  ...e
}) {
  return /* @__PURE__ */ a(v.Sub, { "data-slot": "menubar-sub", ...e });
}
function xo({
  className: e,
  inset: t,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ d(
    v.SubTrigger,
    {
      "data-slot": "menubar-sub-trigger",
      "data-inset": t,
      className: r(
        "flex cursor-default items-center rounded-sm px-2 py-1.5 text-sm outline-none select-none focus:bg-accent focus:text-accent-foreground data-[inset]:pl-8 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground",
        e
      ),
      ...n,
      children: [
        o,
        /* @__PURE__ */ a(B, { className: "ml-auto h-4 w-4" })
      ]
    }
  );
}
function ho({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    v.SubContent,
    {
      "data-slot": "menubar-sub-content",
      className: r(
        "z-50 min-w-[8rem] origin-(--radix-menubar-content-transform-origin) overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...t
    }
  );
}
function wo({
  className: e,
  children: t,
  viewport: o = !0,
  ...n
}) {
  return /* @__PURE__ */ d(
    T.Root,
    {
      "data-slot": "navigation-menu",
      "data-viewport": o,
      className: r(
        "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
        e
      ),
      ...n,
      children: [
        t,
        o && /* @__PURE__ */ a(ct, {})
      ]
    }
  );
}
function No({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    T.List,
    {
      "data-slot": "navigation-menu-list",
      className: r(
        "group flex flex-1 list-none items-center justify-center gap-1",
        e
      ),
      ...t
    }
  );
}
function yo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    T.Item,
    {
      "data-slot": "navigation-menu-item",
      className: r("relative", e),
      ...t
    }
  );
}
const ut = z(
  "group inline-flex h-9 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-[color,box-shadow] outline-none hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 data-[state=open]:bg-accent/50 data-[state=open]:text-accent-foreground data-[state=open]:hover:bg-accent data-[state=open]:focus:bg-accent"
);
function zo({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ d(
    T.Trigger,
    {
      "data-slot": "navigation-menu-trigger",
      className: r(ut(), "group", e),
      ...o,
      children: [
        t,
        " ",
        /* @__PURE__ */ a(
          L,
          {
            className: "relative top-[1px] ml-1 size-3 transition duration-300 group-data-[state=open]:rotate-180",
            "aria-hidden": "true"
          }
        )
      ]
    }
  );
}
function ko({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    T.Content,
    {
      "data-slot": "navigation-menu-content",
      className: r(
        "top-0 left-0 w-full p-2 pr-2.5 data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 data-[motion^=from-]:animate-in data-[motion^=from-]:fade-in data-[motion^=to-]:animate-out data-[motion^=to-]:fade-out md:absolute md:w-auto",
        "group-data-[viewport=false]/navigation-menu:top-full group-data-[viewport=false]/navigation-menu:mt-1.5 group-data-[viewport=false]/navigation-menu:overflow-hidden group-data-[viewport=false]/navigation-menu:rounded-md group-data-[viewport=false]/navigation-menu:border group-data-[viewport=false]/navigation-menu:bg-popover group-data-[viewport=false]/navigation-menu:text-popover-foreground group-data-[viewport=false]/navigation-menu:shadow group-data-[viewport=false]/navigation-menu:duration-200 **:data-[slot=navigation-menu-link]:focus:ring-0 **:data-[slot=navigation-menu-link]:focus:outline-none group-data-[viewport=false]/navigation-menu:data-[state=closed]:animate-out group-data-[viewport=false]/navigation-menu:data-[state=closed]:fade-out-0 group-data-[viewport=false]/navigation-menu:data-[state=closed]:zoom-out-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:animate-in group-data-[viewport=false]/navigation-menu:data-[state=open]:fade-in-0 group-data-[viewport=false]/navigation-menu:data-[state=open]:zoom-in-95",
        e
      ),
      ...t
    }
  );
}
function ct({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      className: r(
        "absolute top-full left-0 isolate z-50 flex justify-center"
      ),
      children: /* @__PURE__ */ a(
        T.Viewport,
        {
          "data-slot": "navigation-menu-viewport",
          className: r(
            "origin-top-center relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border bg-popover text-popover-foreground shadow data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:zoom-in-90 md:w-[var(--radix-navigation-menu-viewport-width)]",
            e
          ),
          ...t
        }
      )
    }
  );
}
function Co({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    T.Link,
    {
      "data-slot": "navigation-menu-link",
      className: r(
        "flex flex-col gap-1 rounded-sm p-2 text-sm transition-all outline-none hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 data-[active=true]:bg-accent/50 data-[active=true]:text-accent-foreground data-[active=true]:hover:bg-accent data-[active=true]:focus:bg-accent [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function _o({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    T.Indicator,
    {
      "data-slot": "navigation-menu-indicator",
      className: r(
        "top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:animate-in data-[state=visible]:fade-in",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a("div", { className: "relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm bg-border shadow-md" })
    }
  );
}
function So({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "nav",
    {
      role: "navigation",
      "aria-label": "pagination",
      "data-slot": "pagination",
      className: r("mx-auto flex w-full justify-center", e),
      ...t
    }
  );
}
function Io({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "ul",
    {
      "data-slot": "pagination-content",
      className: r("flex flex-row items-center gap-1", e),
      ...t
    }
  );
}
function To({ ...e }) {
  return /* @__PURE__ */ a("li", { "data-slot": "pagination-item", ...e });
}
function ge({
  className: e,
  isActive: t,
  size: o = "icon",
  ...n
}) {
  return /* @__PURE__ */ a(
    "a",
    {
      "aria-current": t ? "page" : void 0,
      "data-slot": "pagination-link",
      "data-active": t,
      className: r(
        H({
          variant: t ? "outline" : "ghost",
          size: o
        }),
        e
      ),
      ...n
    }
  );
}
function Mo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ d(
    ge,
    {
      "aria-label": "Go to previous page",
      size: "default",
      className: r("gap-1 px-2.5 sm:pl-2.5", e),
      ...t,
      children: [
        /* @__PURE__ */ a(ne, {}),
        /* @__PURE__ */ a("span", { className: "hidden sm:block", children: "Previous" })
      ]
    }
  );
}
function Ro({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ d(
    ge,
    {
      "aria-label": "Go to next page",
      size: "default",
      className: r("gap-1 px-2.5 sm:pr-2.5", e),
      ...t,
      children: [
        /* @__PURE__ */ a("span", { className: "hidden sm:block", children: "Next" }),
        /* @__PURE__ */ a(B, {})
      ]
    }
  );
}
function Do({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ d(
    "span",
    {
      "aria-hidden": !0,
      "data-slot": "pagination-ellipsis",
      className: r("flex size-9 items-center justify-center", e),
      ...t,
      children: [
        /* @__PURE__ */ a(Ce, { className: "size-4" }),
        /* @__PURE__ */ a("span", { className: "sr-only", children: "More pages" })
      ]
    }
  );
}
function Po({
  ...e
}) {
  return /* @__PURE__ */ a($.Root, { "data-slot": "popover", ...e });
}
function Ao({
  ...e
}) {
  return /* @__PURE__ */ a($.Trigger, { "data-slot": "popover-trigger", ...e });
}
function jo({
  className: e,
  align: t = "center",
  sideOffset: o = 4,
  ...n
}) {
  return /* @__PURE__ */ a($.Portal, { children: /* @__PURE__ */ a(
    $.Content,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: o,
      className: r(
        "z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...n
    }
  ) });
}
function Go({
  ...e
}) {
  return /* @__PURE__ */ a($.Anchor, { "data-slot": "popover-anchor", ...e });
}
function $o({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "popover-header",
      className: r("flex flex-col gap-1 text-sm", e),
      ...t
    }
  );
}
function Lo({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "popover-title",
      className: r("font-medium", e),
      ...t
    }
  );
}
function Bo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "p",
    {
      "data-slot": "popover-description",
      className: r("text-muted-foreground", e),
      ...t
    }
  );
}
function Eo({
  className: e,
  value: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    ae.Root,
    {
      "data-slot": "progress",
      className: r(
        "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
        e
      ),
      ...o,
      children: /* @__PURE__ */ a(
        ae.Indicator,
        {
          "data-slot": "progress-indicator",
          className: "h-full w-full flex-1 bg-primary transition-all",
          style: { transform: `translateX(-${100 - (t || 0)}%)` }
        }
      )
    }
  );
}
function Fo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    J.Root,
    {
      "data-slot": "radio-group",
      className: r("grid gap-3", e),
      ...t
    }
  );
}
function Oo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    J.Item,
    {
      "data-slot": "radio-group-item",
      className: r(
        "aspect-square size-4 shrink-0 rounded-full border border-input text-primary shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:bg-input/30 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(
        J.Indicator,
        {
          "data-slot": "radio-group-indicator",
          className: "relative flex items-center justify-center",
          children: /* @__PURE__ */ a(V, { className: "absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 fill-primary" })
        }
      )
    }
  );
}
function Ho({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    ee.Group,
    {
      "data-slot": "resizable-panel-group",
      className: r(
        "flex h-full w-full aria-[orientation=vertical]:flex-col",
        e
      ),
      ...t
    }
  );
}
function Vo({ ...e }) {
  return /* @__PURE__ */ a(ee.Panel, { "data-slot": "resizable-panel", ...e });
}
function Ko({
  withHandle: e,
  className: t,
  ...o
}) {
  return /* @__PURE__ */ a(
    ee.Separator,
    {
      "data-slot": "resizable-handle",
      className: r(
        "relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:outline-hidden aria-[orientation=horizontal]:h-px aria-[orientation=horizontal]:w-full aria-[orientation=horizontal]:after:left-0 aria-[orientation=horizontal]:after:h-1 aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:translate-x-0 aria-[orientation=horizontal]:after:-translate-y-1/2 [&[aria-orientation=horizontal]>div]:rotate-90",
        t
      ),
      ...o,
      children: e && /* @__PURE__ */ a("div", { className: "z-10 flex h-4 w-3 items-center justify-center rounded-xs border bg-border", children: /* @__PURE__ */ a(_e, { className: "size-2.5" }) })
    }
  );
}
function qo({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ d(
    j.Root,
    {
      "data-slot": "scroll-area",
      className: r("relative", e),
      ...o,
      children: [
        /* @__PURE__ */ a(
          j.Viewport,
          {
            "data-slot": "scroll-area-viewport",
            className: "size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1",
            children: t
          }
        ),
        /* @__PURE__ */ a(mt, {}),
        /* @__PURE__ */ a(j.Corner, {})
      ]
    }
  );
}
function mt({
  className: e,
  orientation: t = "vertical",
  ...o
}) {
  return /* @__PURE__ */ a(
    j.ScrollAreaScrollbar,
    {
      "data-slot": "scroll-area-scrollbar",
      orientation: t,
      className: r(
        "flex touch-none p-px transition-colors select-none",
        t === "vertical" && "h-full w-2.5 border-l border-l-transparent",
        t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent",
        e
      ),
      ...o,
      children: /* @__PURE__ */ a(
        j.ScrollAreaThumb,
        {
          "data-slot": "scroll-area-thumb",
          className: "relative flex-1 rounded-full bg-border"
        }
      )
    }
  );
}
function Wo({
  ...e
}) {
  return /* @__PURE__ */ a(h.Root, { "data-slot": "select", ...e });
}
function Uo({
  ...e
}) {
  return /* @__PURE__ */ a(h.Group, { "data-slot": "select-group", ...e });
}
function Xo({
  ...e
}) {
  return /* @__PURE__ */ a(h.Value, { "data-slot": "select-value", ...e });
}
function Yo({
  className: e,
  size: t = "default",
  children: o,
  ...n
}) {
  return /* @__PURE__ */ d(
    h.Trigger,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: r(
        "flex w-fit items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[placeholder]:text-muted-foreground data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        e
      ),
      ...n,
      children: [
        o,
        /* @__PURE__ */ a(h.Icon, { asChild: !0, children: /* @__PURE__ */ a(L, { className: "size-4 opacity-50" }) })
      ]
    }
  );
}
function Jo({
  className: e,
  children: t,
  position: o = "item-aligned",
  align: n = "center",
  ...i
}) {
  return /* @__PURE__ */ a(h.Portal, { children: /* @__PURE__ */ d(
    h.Content,
    {
      "data-slot": "select-content",
      className: r(
        "relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border bg-popover text-popover-foreground shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        o === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: o,
      align: n,
      ...i,
      children: [
        /* @__PURE__ */ a(gt, {}),
        /* @__PURE__ */ a(
          h.Viewport,
          {
            className: r(
              "p-1",
              o === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ a(pt, {})
      ]
    }
  ) });
}
function Qo({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.Label,
    {
      "data-slot": "select-label",
      className: r("px-2 py-1.5 text-xs text-muted-foreground", e),
      ...t
    }
  );
}
function Zo({
  className: e,
  children: t,
  ...o
}) {
  return /* @__PURE__ */ d(
    h.Item,
    {
      "data-slot": "select-item",
      className: r(
        "relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...o,
      children: [
        /* @__PURE__ */ a(
          "span",
          {
            "data-slot": "select-item-indicator",
            className: "absolute right-2 flex size-3.5 items-center justify-center",
            children: /* @__PURE__ */ a(h.ItemIndicator, { children: /* @__PURE__ */ a(E, { className: "size-4" }) })
          }
        ),
        /* @__PURE__ */ a(h.ItemText, { children: t })
      ]
    }
  );
}
function en({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.Separator,
    {
      "data-slot": "select-separator",
      className: r("pointer-events-none -mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function gt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.ScrollUpButton,
    {
      "data-slot": "select-scroll-up-button",
      className: r(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(Se, { className: "size-4" })
    }
  );
}
function pt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    h.ScrollDownButton,
    {
      "data-slot": "select-scroll-down-button",
      className: r(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(L, { className: "size-4" })
    }
  );
}
function ft({
  className: e,
  orientation: t = "horizontal",
  decorative: o = !0,
  ...n
}) {
  return /* @__PURE__ */ a(
    De.Root,
    {
      "data-slot": "separator",
      decorative: o,
      orientation: t,
      className: r(
        "shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        e
      ),
      ...n
    }
  );
}
function bt({ ...e }) {
  return /* @__PURE__ */ a(g.Root, { "data-slot": "sheet", ...e });
}
function tn({
  ...e
}) {
  return /* @__PURE__ */ a(g.Trigger, { "data-slot": "sheet-trigger", ...e });
}
function an({
  ...e
}) {
  return /* @__PURE__ */ a(g.Close, { "data-slot": "sheet-close", ...e });
}
function vt({
  ...e
}) {
  return /* @__PURE__ */ a(g.Portal, { "data-slot": "sheet-portal", ...e });
}
function xt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    g.Overlay,
    {
      "data-slot": "sheet-overlay",
      className: r(
        "fixed inset-0 z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
        e
      ),
      ...t
    }
  );
}
function ht({
  className: e,
  children: t,
  side: o = "right",
  showCloseButton: n = !0,
  ...i
}) {
  return /* @__PURE__ */ d(vt, { children: [
    /* @__PURE__ */ a(xt, {}),
    /* @__PURE__ */ d(
      g.Content,
      {
        "data-slot": "sheet-content",
        className: r(
          "fixed z-50 flex flex-col gap-4 bg-background shadow-lg transition ease-in-out data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:animate-in data-[state=open]:duration-500",
          o === "right" && "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm",
          o === "left" && "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
          o === "top" && "inset-x-0 top-0 h-auto border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
          o === "bottom" && "inset-x-0 bottom-0 h-auto border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
          e
        ),
        ...i,
        children: [
          t,
          n && /* @__PURE__ */ d(g.Close, { className: "absolute top-4 right-4 rounded-xs opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
            /* @__PURE__ */ a(ie, { className: "size-4" }),
            /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
}
function wt({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sheet-header",
      className: r("flex flex-col gap-1.5 p-4", e),
      ...t
    }
  );
}
function rn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sheet-footer",
      className: r("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
function Nt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    g.Title,
    {
      "data-slot": "sheet-title",
      className: r("font-semibold text-foreground", e),
      ...t
    }
  );
}
function yt({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    g.Description,
    {
      "data-slot": "sheet-description",
      className: r("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function oe({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "skeleton",
      className: r("animate-pulse rounded-md bg-accent", e),
      ...t
    }
  );
}
function zt({
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ a(
    A.Provider,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function kt({
  ...e
}) {
  return /* @__PURE__ */ a(A.Root, { "data-slot": "tooltip", ...e });
}
function Ct({
  ...e
}) {
  return /* @__PURE__ */ a(A.Trigger, { "data-slot": "tooltip-trigger", ...e });
}
function _t({
  className: e,
  sideOffset: t = 0,
  children: o,
  ...n
}) {
  return /* @__PURE__ */ a(A.Portal, { children: /* @__PURE__ */ d(
    A.Content,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: r(
        "z-50 w-fit origin-(--radix-tooltip-content-transform-origin) animate-in rounded-md bg-foreground px-3 py-1.5 text-xs text-balance text-background fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        e
      ),
      ...n,
      children: [
        o,
        /* @__PURE__ */ a(A.Arrow, { className: "z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground" })
      ]
    }
  ) });
}
const St = "sidebar_state", It = 3600 * 24 * 7, Tt = "16rem", Mt = "18rem", Rt = "3rem", Dt = "b", pe = u.createContext(null);
function U() {
  const e = u.useContext(pe);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
function on({
  defaultOpen: e = !0,
  open: t,
  onOpenChange: o,
  className: n,
  style: i,
  children: l,
  ...p
}) {
  const x = Ke(), [s, c] = u.useState(!1), [w, k] = u.useState(e), R = t ?? w, y = u.useCallback(
    (m) => {
      const I = typeof m == "function" ? m(R) : m;
      o ? o(I) : k(I), document.cookie = `${St}=${I}; path=/; max-age=${It}`;
    },
    [o, R]
  ), S = u.useCallback(() => x ? c((m) => !m) : y((m) => !m), [x, y, c]);
  u.useEffect(() => {
    const m = (I) => {
      I.key === Dt && (I.metaKey || I.ctrlKey) && (I.preventDefault(), S());
    };
    return window.addEventListener("keydown", m), () => window.removeEventListener("keydown", m);
  }, [S]);
  const P = R ? "expanded" : "collapsed", X = u.useMemo(
    () => ({
      state: P,
      open: R,
      setOpen: y,
      isMobile: x,
      openMobile: s,
      setOpenMobile: c,
      toggleSidebar: S
    }),
    [P, R, y, x, s, c, S]
  );
  return /* @__PURE__ */ a(pe.Provider, { value: X, children: /* @__PURE__ */ a(zt, { delayDuration: 0, children: /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-wrapper",
      style: {
        "--sidebar-width": Tt,
        "--sidebar-width-icon": Rt,
        ...i
      },
      className: r(
        "group/sidebar-wrapper flex min-h-svh w-full has-data-[variant=inset]:bg-sidebar",
        n
      ),
      ...p,
      children: l
    }
  ) }) });
}
function nn({
  side: e = "left",
  variant: t = "sidebar",
  collapsible: o = "offcanvas",
  className: n,
  children: i,
  ...l
}) {
  const { isMobile: p, state: x, openMobile: s, setOpenMobile: c } = U();
  return o === "none" ? /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar",
      className: r(
        "flex h-full w-(--sidebar-width) flex-col bg-sidebar text-sidebar-foreground",
        n
      ),
      ...l,
      children: i
    }
  ) : p ? /* @__PURE__ */ a(bt, { open: s, onOpenChange: c, ...l, children: /* @__PURE__ */ d(
    ht,
    {
      "data-sidebar": "sidebar",
      "data-slot": "sidebar",
      "data-mobile": "true",
      className: "w-(--sidebar-width) bg-sidebar p-0 text-sidebar-foreground [&>button]:hidden",
      style: {
        "--sidebar-width": Mt
      },
      side: e,
      children: [
        /* @__PURE__ */ d(wt, { className: "sr-only", children: [
          /* @__PURE__ */ a(Nt, { children: "Sidebar" }),
          /* @__PURE__ */ a(yt, { children: "Displays the mobile sidebar." })
        ] }),
        /* @__PURE__ */ a("div", { className: "flex h-full w-full flex-col", children: i })
      ]
    }
  ) }) : /* @__PURE__ */ d(
    "div",
    {
      className: "group peer hidden text-sidebar-foreground md:block",
      "data-state": x,
      "data-collapsible": x === "collapsed" ? o : "",
      "data-variant": t,
      "data-side": e,
      "data-slot": "sidebar",
      children: [
        /* @__PURE__ */ a(
          "div",
          {
            "data-slot": "sidebar-gap",
            className: r(
              "relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
              "group-data-[collapsible=offcanvas]:w-0",
              "group-data-[side=right]:rotate-180",
              t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
            )
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            "data-slot": "sidebar-container",
            className: r(
              "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
              e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
              // Adjust the padding for floating and inset variants.
              t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
              n
            ),
            ...l,
            children: /* @__PURE__ */ a(
              "div",
              {
                "data-sidebar": "sidebar",
                "data-slot": "sidebar-inner",
                className: "flex h-full w-full flex-col bg-sidebar group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:border-sidebar-border group-data-[variant=floating]:shadow-sm",
                children: i
              }
            )
          }
        )
      ]
    }
  );
}
function sn({
  className: e,
  onClick: t,
  ...o
}) {
  const { toggleSidebar: n } = U();
  return /* @__PURE__ */ d(
    M,
    {
      "data-sidebar": "trigger",
      "data-slot": "sidebar-trigger",
      variant: "ghost",
      size: "icon",
      className: r("size-7", e),
      onClick: (i) => {
        t?.(i), n();
      },
      ...o,
      children: [
        /* @__PURE__ */ a(Ie, {}),
        /* @__PURE__ */ a("span", { className: "sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
}
function dn({ className: e, ...t }) {
  const { toggleSidebar: o } = U();
  return /* @__PURE__ */ a(
    "button",
    {
      "data-sidebar": "rail",
      "data-slot": "sidebar-rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: o,
      title: "Toggle Sidebar",
      className: r(
        "absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear group-data-[side=left]:-right-4 group-data-[side=right]:left-0 after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] hover:after:bg-sidebar-border sm:flex",
        "in-data-[side=left]:cursor-w-resize in-data-[side=right]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full hover:group-data-[collapsible=offcanvas]:bg-sidebar",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        e
      ),
      ...t
    }
  );
}
function ln({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "main",
    {
      "data-slot": "sidebar-inset",
      className: r(
        "relative flex w-full flex-1 flex-col bg-background",
        "md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-2",
        e
      ),
      ...t
    }
  );
}
function un({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    me,
    {
      "data-slot": "sidebar-input",
      "data-sidebar": "input",
      className: r("h-8 w-full bg-background shadow-none", e),
      ...t
    }
  );
}
function cn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-header",
      "data-sidebar": "header",
      className: r("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function mn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-footer",
      "data-sidebar": "footer",
      className: r("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function gn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    ft,
    {
      "data-slot": "sidebar-separator",
      "data-sidebar": "separator",
      className: r("mx-2 w-auto bg-sidebar-border", e),
      ...t
    }
  );
}
function pn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-content",
      "data-sidebar": "content",
      className: r(
        "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
        e
      ),
      ...t
    }
  );
}
function fn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-group",
      "data-sidebar": "group",
      className: r("relative flex w-full min-w-0 flex-col p-2", e),
      ...t
    }
  );
}
function bn({
  className: e,
  asChild: t = !1,
  ...o
}) {
  const n = t ? C.Root : "div";
  return /* @__PURE__ */ a(
    n,
    {
      "data-slot": "sidebar-group-label",
      "data-sidebar": "group-label",
      className: r(
        "flex h-8 shrink-0 items-center rounded-md px-2 text-xs font-medium text-sidebar-foreground/70 ring-sidebar-ring outline-hidden transition-[margin,opacity] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0",
        e
      ),
      ...o
    }
  );
}
function vn({
  className: e,
  asChild: t = !1,
  ...o
}) {
  const n = t ? C.Root : "button";
  return /* @__PURE__ */ a(
    n,
    {
      "data-slot": "sidebar-group-action",
      "data-sidebar": "group-action",
      className: r(
        "absolute top-3.5 right-3 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-sidebar-foreground ring-sidebar-ring outline-hidden transition-transform hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        // Increases the hit area of the button on mobile.
        "after:absolute after:-inset-2 md:after:hidden",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...o
    }
  );
}
function xn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-group-content",
      "data-sidebar": "group-content",
      className: r("w-full text-sm", e),
      ...t
    }
  );
}
function hn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: r("flex w-full min-w-0 flex-col gap-1", e),
      ...t
    }
  );
}
function wn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: r("group/menu-item relative", e),
      ...t
    }
  );
}
const Pt = z(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm ring-sidebar-ring outline-hidden transition-[width,height,padding] group-has-data-[sidebar=menu-action]/menu-item:pr-8 group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_var(--sidebar-border)] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_var(--sidebar-accent)]"
      },
      size: {
        default: "h-8 text-sm",
        sm: "h-7 text-xs",
        lg: "h-12 text-sm group-data-[collapsible=icon]:p-0!"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function Nn({
  asChild: e = !1,
  isActive: t = !1,
  variant: o = "default",
  size: n = "default",
  tooltip: i,
  className: l,
  ...p
}) {
  const x = e ? C.Root : "button", { isMobile: s, state: c } = U(), w = /* @__PURE__ */ a(
    x,
    {
      "data-slot": "sidebar-menu-button",
      "data-sidebar": "menu-button",
      "data-size": n,
      "data-active": t,
      className: r(Pt({ variant: o, size: n }), l),
      ...p
    }
  );
  return i ? (typeof i == "string" && (i = {
    children: i
  }), /* @__PURE__ */ d(kt, { children: [
    /* @__PURE__ */ a(Ct, { asChild: !0, children: w }),
    /* @__PURE__ */ a(
      _t,
      {
        side: "right",
        align: "center",
        hidden: c !== "collapsed" || s,
        ...i
      }
    )
  ] })) : w;
}
function yn({
  className: e,
  asChild: t = !1,
  showOnHover: o = !1,
  ...n
}) {
  const i = t ? C.Root : "button";
  return /* @__PURE__ */ a(
    i,
    {
      "data-slot": "sidebar-menu-action",
      "data-sidebar": "menu-action",
      className: r(
        "absolute top-1.5 right-1 flex aspect-square w-5 items-center justify-center rounded-md p-0 text-sidebar-foreground ring-sidebar-ring outline-hidden transition-transform peer-hover/menu-button:text-sidebar-accent-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
        // Increases the hit area of the button on mobile.
        "after:absolute after:-inset-2 md:after:hidden",
        "peer-data-[size=sm]/menu-button:top-1",
        "peer-data-[size=default]/menu-button:top-1.5",
        "peer-data-[size=lg]/menu-button:top-2.5",
        "group-data-[collapsible=icon]:hidden",
        o && "group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 peer-data-[active=true]/menu-button:text-sidebar-accent-foreground data-[state=open]:opacity-100 md:opacity-0",
        e
      ),
      ...n
    }
  );
}
function zn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "sidebar-menu-badge",
      "data-sidebar": "menu-badge",
      className: r(
        "pointer-events-none absolute right-1 flex h-5 min-w-5 items-center justify-center rounded-md px-1 text-xs font-medium text-sidebar-foreground tabular-nums select-none",
        "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
        "peer-data-[size=sm]/menu-button:top-1",
        "peer-data-[size=default]/menu-button:top-1.5",
        "peer-data-[size=lg]/menu-button:top-2.5",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...t
    }
  );
}
function kn({
  className: e,
  showIcon: t = !1,
  ...o
}) {
  const n = u.useMemo(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
  return /* @__PURE__ */ d(
    "div",
    {
      "data-slot": "sidebar-menu-skeleton",
      "data-sidebar": "menu-skeleton",
      className: r("flex h-8 items-center gap-2 rounded-md px-2", e),
      ...o,
      children: [
        t && /* @__PURE__ */ a(
          oe,
          {
            className: "size-4 rounded-md",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ a(
          oe,
          {
            className: "h-4 max-w-(--skeleton-width) flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": n
            }
          }
        )
      ]
    }
  );
}
function Cn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "ul",
    {
      "data-slot": "sidebar-menu-sub",
      "data-sidebar": "menu-sub",
      className: r(
        "mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l border-sidebar-border px-2.5 py-0.5",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...t
    }
  );
}
function _n({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "li",
    {
      "data-slot": "sidebar-menu-sub-item",
      "data-sidebar": "menu-sub-item",
      className: r("group/menu-sub-item relative", e),
      ...t
    }
  );
}
function Sn({
  asChild: e = !1,
  size: t = "md",
  isActive: o = !1,
  className: n,
  ...i
}) {
  const l = e ? C.Root : "a";
  return /* @__PURE__ */ a(
    l,
    {
      "data-slot": "sidebar-menu-sub-button",
      "data-sidebar": "menu-sub-button",
      "data-size": t,
      "data-active": o,
      className: r(
        "flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 text-sidebar-foreground ring-sidebar-ring outline-hidden hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:text-sidebar-accent-foreground",
        "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
        t === "sm" && "text-xs",
        t === "md" && "text-sm",
        "group-data-[collapsible=icon]:hidden",
        n
      ),
      ...i
    }
  );
}
function In({
  className: e,
  defaultValue: t,
  value: o,
  min: n = 0,
  max: i = 100,
  ...l
}) {
  const p = u.useMemo(
    () => Array.isArray(o) ? o : Array.isArray(t) ? t : [n, i],
    [o, t, n, i]
  );
  return /* @__PURE__ */ d(
    F.Root,
    {
      "data-slot": "slider",
      defaultValue: t,
      value: o,
      min: n,
      max: i,
      className: r(
        "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        e
      ),
      ...l,
      children: [
        /* @__PURE__ */ a(
          F.Track,
          {
            "data-slot": "slider-track",
            className: r(
              "relative grow overflow-hidden rounded-full bg-muted data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
            ),
            children: /* @__PURE__ */ a(
              F.Range,
              {
                "data-slot": "slider-range",
                className: r(
                  "absolute bg-primary data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
                )
              }
            )
          }
        ),
        Array.from({ length: p.length }, (x, s) => /* @__PURE__ */ a(
          F.Thumb,
          {
            "data-slot": "slider-thumb",
            className: "block size-4 shrink-0 rounded-full border border-primary bg-white shadow-sm ring-ring/50 transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
          },
          s
        ))
      ]
    }
  );
}
const Tn = (e) => /* @__PURE__ */ a(
  Ve,
  {
    className: "toaster group",
    toastOptions: {
      classNames: {
        toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-muted-foreground",
        actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
      }
    },
    ...e
  }
);
function Mn({
  className: e,
  size: t = "default",
  ...o
}) {
  return /* @__PURE__ */ a(
    re.Root,
    {
      "data-slot": "switch",
      "data-size": t,
      className: r(
        "peer group/switch inline-flex shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-[1.15rem] data-[size=default]:w-8 data-[size=sm]:h-3.5 data-[size=sm]:w-6 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80",
        e
      ),
      ...o,
      children: /* @__PURE__ */ a(
        re.Thumb,
        {
          "data-slot": "switch-thumb",
          className: r(
            "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0 dark:data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-foreground"
          )
        }
      )
    }
  );
}
function Rn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "table-container",
      className: "relative w-full overflow-x-auto",
      children: /* @__PURE__ */ a(
        "table",
        {
          "data-slot": "table",
          className: r("w-full caption-bottom text-sm", e),
          ...t
        }
      )
    }
  );
}
function Dn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "thead",
    {
      "data-slot": "table-header",
      className: r("[&_tr]:border-b", e),
      ...t
    }
  );
}
function Pn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "tbody",
    {
      "data-slot": "table-body",
      className: r("[&_tr:last-child]:border-0", e),
      ...t
    }
  );
}
function An({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "tfoot",
    {
      "data-slot": "table-footer",
      className: r(
        "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
        e
      ),
      ...t
    }
  );
}
function jn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "tr",
    {
      "data-slot": "table-row",
      className: r(
        "border-b transition-colors hover:bg-muted/50 has-aria-expanded:bg-muted/50 data-[state=selected]:bg-muted",
        e
      ),
      ...t
    }
  );
}
function Gn({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "th",
    {
      "data-slot": "table-head",
      className: r(
        "h-10 px-2 text-left align-middle font-medium whitespace-nowrap text-foreground [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        e
      ),
      ...t
    }
  );
}
function $n({ className: e, ...t }) {
  return /* @__PURE__ */ a(
    "td",
    {
      "data-slot": "table-cell",
      className: r(
        "p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        e
      ),
      ...t
    }
  );
}
function Ln({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    "caption",
    {
      "data-slot": "table-caption",
      className: r("mt-4 text-sm text-muted-foreground", e),
      ...t
    }
  );
}
const Bn = N.Provider, At = u.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ a(
  N.Viewport,
  {
    ref: o,
    className: r(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:top-auto sm:right-0 sm:bottom-0 sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
At.displayName = N.Viewport.displayName;
const jt = z(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Gt = u.forwardRef(({ className: e, variant: t, ...o }, n) => /* @__PURE__ */ a(
  N.Root,
  {
    ref: n,
    className: r(jt({ variant: t }), e),
    ...o
  }
));
Gt.displayName = N.Root.displayName;
const $t = u.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ a(
  N.Action,
  {
    ref: o,
    className: r(
      "hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors focus:ring-1 focus:outline-none disabled:pointer-events-none disabled:opacity-50",
      e
    ),
    ...t
  }
));
$t.displayName = N.Action.displayName;
const Lt = u.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ a(
  N.Close,
  {
    ref: o,
    className: r(
      "text-foreground/50 hover:text-foreground absolute top-1 right-1 rounded-md p-1 opacity-0 transition-opacity group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 focus:opacity-100 focus:ring-1 focus:outline-none group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ a(Te, { className: "h-4 w-4" })
  }
));
Lt.displayName = N.Close.displayName;
const Bt = u.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ a(
  N.Title,
  {
    ref: o,
    className: r("text-sm font-semibold [&+div]:text-xs", e),
    ...t
  }
));
Bt.displayName = N.Title.displayName;
const Et = u.forwardRef(({ className: e, ...t }, o) => /* @__PURE__ */ a(
  N.Description,
  {
    ref: o,
    className: r("text-sm opacity-90", e),
    ...t
  }
));
Et.displayName = N.Description.displayName;
const fe = z(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-[color,box-shadow] outline-none hover:bg-muted hover:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-9 min-w-9 px-2",
        sm: "h-8 min-w-8 px-1.5",
        lg: "h-10 min-w-10 px-2.5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function En({
  className: e,
  variant: t,
  size: o,
  ...n
}) {
  return /* @__PURE__ */ a(
    Pe.Root,
    {
      "data-slot": "toggle",
      className: r(fe({ variant: t, size: o, className: e })),
      ...n
    }
  );
}
const be = u.createContext({
  size: "default",
  variant: "default",
  spacing: 0
});
function Fn({
  className: e,
  variant: t,
  size: o,
  spacing: n = 0,
  children: i,
  ...l
}) {
  return /* @__PURE__ */ a(
    se.Root,
    {
      "data-slot": "toggle-group",
      "data-variant": t,
      "data-size": o,
      "data-spacing": n,
      style: { "--gap": n },
      className: r(
        "group/toggle-group flex w-fit items-center gap-[--spacing(var(--gap))] rounded-md data-[spacing=default]:data-[variant=outline]:shadow-xs",
        e
      ),
      ...l,
      children: /* @__PURE__ */ a(be.Provider, { value: { variant: t, size: o, spacing: n }, children: i })
    }
  );
}
function On({
  className: e,
  children: t,
  variant: o,
  size: n,
  ...i
}) {
  const l = u.useContext(be);
  return /* @__PURE__ */ a(
    se.Item,
    {
      "data-slot": "toggle-group-item",
      "data-variant": l.variant || o,
      "data-size": l.size || n,
      "data-spacing": l.spacing,
      className: r(
        fe({
          variant: l.variant || o,
          size: l.size || n
        }),
        "w-auto min-w-0 shrink-0 px-3 focus:z-10 focus-visible:z-10",
        "data-[spacing=0]:rounded-none data-[spacing=0]:shadow-none data-[spacing=0]:first:rounded-l-md data-[spacing=0]:last:rounded-r-md data-[spacing=0]:data-[variant=outline]:border-l-0 data-[spacing=0]:data-[variant=outline]:first:border-l",
        e
      ),
      ...i,
      children: t
    }
  );
}
function Hn({
  className: e,
  orientation: t = "horizontal",
  ...o
}) {
  return /* @__PURE__ */ a(
    K.Root,
    {
      "data-slot": "tabs",
      "data-orientation": t,
      orientation: t,
      className: r(
        "group/tabs flex gap-2 data-[orientation=horizontal]:flex-col",
        e
      ),
      ...o
    }
  );
}
const Ft = z(
  "group/tabs-list inline-flex w-fit items-center justify-center rounded-lg p-[3px] text-muted-foreground group-data-[orientation=horizontal]/tabs:h-9 group-data-[orientation=vertical]/tabs:h-fit group-data-[orientation=vertical]/tabs:flex-col data-[variant=line]:rounded-none",
  {
    variants: {
      variant: {
        default: "bg-muted",
        line: "gap-1 bg-transparent"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Vn({
  className: e,
  variant: t = "default",
  ...o
}) {
  return /* @__PURE__ */ a(
    K.List,
    {
      "data-slot": "tabs-list",
      "data-variant": t,
      className: r(Ft({ variant: t }), e),
      ...o
    }
  );
}
function Kn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    K.Trigger,
    {
      "data-slot": "tabs-trigger",
      className: r(
        "relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-2 py-1 text-sm font-medium whitespace-nowrap text-foreground/60 transition-all group-data-[orientation=vertical]/tabs:w-full group-data-[orientation=vertical]/tabs:justify-start hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 group-data-[variant=default]/tabs-list:data-[state=active]:shadow-sm group-data-[variant=line]/tabs-list:data-[state=active]:shadow-none dark:text-muted-foreground dark:hover:text-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        "group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent dark:group-data-[variant=line]/tabs-list:data-[state=active]:border-transparent dark:group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent",
        "data-[state=active]:bg-background data-[state=active]:text-foreground dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 dark:data-[state=active]:text-foreground",
        "after:absolute after:bg-foreground after:opacity-0 after:transition-opacity group-data-[orientation=horizontal]/tabs:after:inset-x-0 group-data-[orientation=horizontal]/tabs:after:bottom-[-5px] group-data-[orientation=horizontal]/tabs:after:h-0.5 group-data-[orientation=vertical]/tabs:after:inset-y-0 group-data-[orientation=vertical]/tabs:after:-right-1 group-data-[orientation=vertical]/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-[state=active]:after:opacity-100",
        e
      ),
      ...t
    }
  );
}
function qn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ a(
    K.Content,
    {
      "data-slot": "tabs-content",
      className: r("flex-1 outline-none", e),
      ...t
    }
  );
}
export {
  aa as Accordion,
  na as AccordionContent,
  ra as AccordionItem,
  oa as AccordionTrigger,
  ia as Alert,
  da as AlertDescription,
  la as AlertDialog,
  va as AlertDialogAction,
  xa as AlertDialogCancel,
  ca as AlertDialogContent,
  fa as AlertDialogDescription,
  ga as AlertDialogFooter,
  ma as AlertDialogHeader,
  ba as AlertDialogMedia,
  Ue as AlertDialogOverlay,
  We as AlertDialogPortal,
  pa as AlertDialogTitle,
  ua as AlertDialogTrigger,
  sa as AlertTitle,
  ha as AspectRatio,
  wa as Avatar,
  za as AvatarBadge,
  ya as AvatarFallback,
  ka as AvatarGroup,
  Ca as AvatarGroupCount,
  Na as AvatarImage,
  _a as Badge,
  Sa as Breadcrumb,
  Pa as BreadcrumbEllipsis,
  Ta as BreadcrumbItem,
  Ma as BreadcrumbLink,
  Ia as BreadcrumbList,
  Ra as BreadcrumbPage,
  Da as BreadcrumbSeparator,
  M as Button,
  Aa as Calendar,
  Ye as CalendarDayButton,
  ja as Card,
  Ba as CardAction,
  Ea as CardContent,
  La as CardDescription,
  Fa as CardFooter,
  Ga as CardHeader,
  $a as CardTitle,
  Oa as Carousel,
  Ha as CarouselContent,
  Va as CarouselItem,
  qa as CarouselNext,
  Ka as CarouselPrevious,
  Wa as Checkbox,
  Ua as Collapsible,
  Ya as CollapsibleContent,
  Xa as CollapsibleTrigger,
  ot as Command,
  er as CommandDialog,
  rr as CommandEmpty,
  or as CommandGroup,
  tr as CommandInput,
  ir as CommandItem,
  ar as CommandList,
  nr as CommandSeparator,
  sr as CommandShortcut,
  dr as ContextMenu,
  xr as ContextMenuCheckboxItem,
  br as ContextMenuContent,
  ur as ContextMenuGroup,
  vr as ContextMenuItem,
  wr as ContextMenuLabel,
  cr as ContextMenuPortal,
  gr as ContextMenuRadioGroup,
  hr as ContextMenuRadioItem,
  Nr as ContextMenuSeparator,
  yr as ContextMenuShortcut,
  mr as ContextMenuSub,
  fr as ContextMenuSubContent,
  pr as ContextMenuSubTrigger,
  lr as ContextMenuTrigger,
  Je as Dialog,
  Qa as DialogClose,
  et as DialogContent,
  rt as DialogDescription,
  Za as DialogFooter,
  tt as DialogHeader,
  Ze as DialogOverlay,
  Qe as DialogPortal,
  at as DialogTitle,
  Ja as DialogTrigger,
  zr as DropdownMenu,
  Tr as DropdownMenuCheckboxItem,
  _r as DropdownMenuContent,
  Sr as DropdownMenuGroup,
  Ir as DropdownMenuItem,
  Dr as DropdownMenuLabel,
  kr as DropdownMenuPortal,
  Mr as DropdownMenuRadioGroup,
  Rr as DropdownMenuRadioItem,
  Pr as DropdownMenuSeparator,
  Ar as DropdownMenuShortcut,
  jr as DropdownMenuSub,
  $r as DropdownMenuSubContent,
  Gr as DropdownMenuSubTrigger,
  Cr as DropdownMenuTrigger,
  Lr as Form,
  Or as FormControl,
  Hr as FormDescription,
  Br as FormField,
  Er as FormItem,
  Fr as FormLabel,
  Vr as FormMessage,
  Kr as HoverCard,
  Wr as HoverCardContent,
  qr as HoverCardTrigger,
  me as Input,
  Ur as InputGroup,
  Xr as InputGroupAddon,
  Yr as InputGroupButton,
  Qr as InputGroupInput,
  Jr as InputGroupText,
  Zr as InputGroupTextarea,
  eo as InputOTP,
  to as InputOTPGroup,
  ro as InputOTPSeparator,
  ao as InputOTPSlot,
  nt as Label,
  oo as Menubar,
  mo as MenubarCheckboxItem,
  uo as MenubarContent,
  io as MenubarGroup,
  co as MenubarItem,
  po as MenubarLabel,
  no as MenubarMenu,
  lt as MenubarPortal,
  so as MenubarRadioGroup,
  go as MenubarRadioItem,
  fo as MenubarSeparator,
  bo as MenubarShortcut,
  vo as MenubarSub,
  ho as MenubarSubContent,
  xo as MenubarSubTrigger,
  lo as MenubarTrigger,
  wo as NavigationMenu,
  ko as NavigationMenuContent,
  _o as NavigationMenuIndicator,
  yo as NavigationMenuItem,
  Co as NavigationMenuLink,
  No as NavigationMenuList,
  zo as NavigationMenuTrigger,
  ct as NavigationMenuViewport,
  So as Pagination,
  Io as PaginationContent,
  Do as PaginationEllipsis,
  To as PaginationItem,
  ge as PaginationLink,
  Ro as PaginationNext,
  Mo as PaginationPrevious,
  Po as Popover,
  Go as PopoverAnchor,
  jo as PopoverContent,
  Bo as PopoverDescription,
  $o as PopoverHeader,
  Lo as PopoverTitle,
  Ao as PopoverTrigger,
  Eo as Progress,
  Fo as RadioGroup,
  Oo as RadioGroupItem,
  Ko as ResizableHandle,
  Vo as ResizablePanel,
  Ho as ResizablePanelGroup,
  qo as ScrollArea,
  mt as ScrollBar,
  Wo as Select,
  Jo as SelectContent,
  Uo as SelectGroup,
  Zo as SelectItem,
  Qo as SelectLabel,
  pt as SelectScrollDownButton,
  gt as SelectScrollUpButton,
  en as SelectSeparator,
  Yo as SelectTrigger,
  Xo as SelectValue,
  ft as Separator,
  bt as Sheet,
  an as SheetClose,
  ht as SheetContent,
  yt as SheetDescription,
  rn as SheetFooter,
  wt as SheetHeader,
  Nt as SheetTitle,
  tn as SheetTrigger,
  nn as Sidebar,
  pn as SidebarContent,
  mn as SidebarFooter,
  fn as SidebarGroup,
  vn as SidebarGroupAction,
  xn as SidebarGroupContent,
  bn as SidebarGroupLabel,
  cn as SidebarHeader,
  un as SidebarInput,
  ln as SidebarInset,
  hn as SidebarMenu,
  yn as SidebarMenuAction,
  zn as SidebarMenuBadge,
  Nn as SidebarMenuButton,
  wn as SidebarMenuItem,
  kn as SidebarMenuSkeleton,
  Cn as SidebarMenuSub,
  Sn as SidebarMenuSubButton,
  _n as SidebarMenuSubItem,
  on as SidebarProvider,
  dn as SidebarRail,
  gn as SidebarSeparator,
  sn as SidebarTrigger,
  oe as Skeleton,
  In as Slider,
  Mn as Switch,
  Rn as Table,
  Pn as TableBody,
  Ln as TableCaption,
  $n as TableCell,
  An as TableFooter,
  Gn as TableHead,
  Dn as TableHeader,
  jn as TableRow,
  Hn as Tabs,
  qn as TabsContent,
  Vn as TabsList,
  Kn as TabsTrigger,
  it as Textarea,
  Gt as Toast,
  $t as ToastAction,
  Lt as ToastClose,
  Et as ToastDescription,
  Bn as ToastProvider,
  Bt as ToastTitle,
  At as ToastViewport,
  Tn as Toaster,
  En as Toggle,
  Fn as ToggleGroup,
  On as ToggleGroupItem,
  kt as Tooltip,
  _t as TooltipContent,
  zt as TooltipProvider,
  Ct as TooltipTrigger,
  Xe as badgeVariants,
  H as buttonVariants,
  r as cn,
  ut as navigationMenuTriggerStyle,
  Ft as tabsListVariants,
  fe as toggleVariants,
  W as useFormField,
  Ke as useIsMobile,
  ta as useShortHeight,
  U as useSidebar
};
//# sourceMappingURL=index.js.map
